import React from "react";

import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import { getCurrencyIcon } from "../../Helpers/currencyConverter";
import { isStorefrontFoundationEnabled } from "../Storefront/featureFlags";
import { formatMoney } from "../Storefront/presentation/money";

class Category extends React.Component {
  render() {
    const { language, min_order, settings } = this.props;
    if (isStorefrontFoundationEnabled(settings)) {
      const name = this.props.text;
      return <div id={`navigate${this.props.id}`} className="sf-section-heading" dir={language === "arabic" ? "rtl" : "ltr"}>
        <h2>{name}
          {settings.show_prices !== false && !settings.is_menu && Number(min_order) > 0 && <small>
            {language === "arabic" ? "الحد الأدنى للطلب: " : "Min. order: "}
            <bdi>{formatMoney(min_order, { settings, language })}</bdi>
          </small>}
        </h2>
        {!this.props.filter && this.props.onClick && <button type="button"
          aria-label={language === "arabic" ? "تصفح الأقسام" : "Browse categories"}
          onClick={() => this.props.onClick(this.props.id)} style={{ color: settings.dark || "#0099cc" }}>
          <MoreHorizIcon aria-hidden="true" />
        </button>}
      </div>;
    }
    const currencyIcon = getCurrencyIcon(settings)
    let min_order_text = min_order ? (
      language === "english" ? (
        <span>
          {"( Min Order "}
          <span className={currencyIcon}>
            {min_order} {settings?.currency_english}
          </span>
          {" )"}
        </span>
      ) : (
        <span>
          {"( الحد الأدنى"}
          <span className={currencyIcon}>
            {min_order} {settings?.currency_local}
          </span>
          {" )"}
        </span>
      )
    ) : null;

    return (
      <>
        <div id={"navigate" + this.props.id} style={{ width: "100%" }}></div>

        <div
          className={"category_menu my-auto "}
          style={this.props.style}
          onClick={() => {
            if (!this.props.filter) {
              this.props.onClick(this.props.id);
            }
          }}
        >
          <h5
            className={`${language === "arabic" ? "text-right" : ""} 
            `}
            style={{
              fontFamily: language == "english" ? "Quicksand" : "Cairo",
            }}
          >
            {this.props.text} {min_order_text ? min_order_text : ""}
            {!this.props.filter && (
              <span
                className={`${
                  language === "english" ? "float-right" : "float-left"
                }`}
              >
                <MoreHorizIcon />
              </span>
            )}
          </h5>
        </div>
      </>
    );
  }
}

export default Category;
